/**
 * Attributes that keep a phone's browser from taking a video over: Safari's
 * fullscreen player, its control bar and its picture-in-picture button.
 *
 * `webkit-playsinline` is the pre-iOS-10 spelling. React has no prop for it, so
 * it goes through as a plain attribute. Spread into a <video> on mobile only:
 * none of it does anything on desktop, and desktop renders exactly as before.
 */
export const PHONE_INLINE_EXTRAS = {
  'webkit-playsinline': 'true',
  disablePictureInPicture: true,
} as const;
export const PHONE_INLINE_VIDEO = { playsInline: true, ...PHONE_INLINE_EXTRAS } as const;
